var Pmp = Pmp || {};
Pmp.Common = Pmp.Common || {};
Pmp.Common.Entity = Pmp.Common.Entity || {};

Pmp.Common.Entity.Users = {
	initialize: function() {
		this.bindEventHandlers()
	},

	bindEventHandlers: function() {
		$('#user-session-logout').click(function() {
			$.ajax({
				url: '/force-sessions-logout',
				type: 'POST',
				data: {},
				error: function (_) {
					console.log('Error logging out all active sessions');
				},
				success: function (_) {
					window.location.reload()
				}
			})
		})
	}
}